module.exports = __webpack_public_path__ + "img/logo_am_blue.7a37c37.png";